var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillOpacity":".5","fillRule":"evenodd","d":"M14.362 4.008c.009.135.009.27.009.406 0 4.121-3.3 8.869-9.335 8.869A9.615 9.615 0 0 1 0 11.883c.263.029.517.038.791.038a6.794 6.794 0 0 0 4.074-1.332c-1.441-.028-2.652-.926-3.068-2.161.493.08.998.062 1.483-.057C1.777 8.081.649 6.827.649 5.311v-.039c.437.232.945.376 1.483.395C1.25 5.108.669 4.152.669 3.072c0-.579.163-1.11.447-1.573C2.731 3.39 5.16 4.626 7.881 4.761a3.404 3.404 0 0 1-.08-.714c0-1.718 1.461-3.117 3.28-3.117.945 0 1.798.376 2.397.984a6.654 6.654 0 0 0 2.083-.753 3.15 3.15 0 0 1-1.443 1.719 6.885 6.885 0 0 0 1.889-.483"}));
}

Twitter.defaultProps = {"width":"16","height":"14","viewBox":"0 0 16 14"};

module.exports = Twitter;

Twitter.default = Twitter;
